import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';

export const groupDashboardRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/dashboard',
}).lazy(() => import('pages/group/Dashboard/GroupDashboardPage').then((d) => d.Route));
